import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import FormGroup from '../helpers/FormGroup'

class CompanyPeople extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const values = this.props.person
    const setData = this.props.setData

    const jacketSizes = [
      'Womens XS',
      'Womens S',
      'Womens M',
      'Womens L',
      'Womens XL',
      'Mens S',
      'Mens M',
      'Mens L',
      'Mens XL',
      'Mens XXL'
    ]

    return(
      <div>
        <div className="row">
          <div className="col-12 col-sm-6">
            <FormGroup label="First Name" value={values.first_name} onChange={(v) => setData({first_name: v})} errors={values.errors['first_name']} />
          </div>
          <div className="col-12 col-sm-6">
            <FormGroup label="Last Name" value={values.last_name} onChange={(v) => setData({last_name: v})} errors={values.errors['last_name']} />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6">
            <FormGroup label="Title" value={values.title} onChange={(v) => setData({title: v})} errors={values.errors['title']} />
          </div>
          <div className="col-12 col-sm-6">
            <FormGroup label="Email" value={values.email} onChange={(v) => setData({email: v})} errors={values.errors['email']} />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6">
            <FormGroup label="LinkedIn URL" value={values.linkedin_url} onChange={(v) => setData({linkedin_url: v})} />
          </div>
          <div className="col-12 col-sm-6">
            <FormGroup label="Twitter Handle" value={values.twitter} onChange={(v) => setData({twitter: v})} />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-sm-6">
            <FormGroup label="Assistant's Name" value={values.assistant_name} onChange={(v) => setData({assistant_name: v})} />
          </div>
          <div className="col-12 col-sm-6">
            <FormGroup label="Assistant's Email" value={values.assistant_email} onChange={(v) => setData({assistant_email: v})} errors={values.errors['assistant_email']} />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Jacket Sizing</label>
              <select className="form-control" name="size" value={values.size} onChange={(e) => setData({size: e.target.value})}>
                <option value=""></option>
                {jacketSizes.map((size) =>
                  <option key={size} value={size}>{size}</option>
                )}
              </select>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CompanyPeople